<template>
    <div class="step4">
        <h1>Aanvraagformulier</h1>
        <h2>Financiële bezittingen</h2>

        <application-stepper current-step="4" :loading="!loaded">
            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <h3>Schulden</h3>

                <v-switch class="pl-4" v-model="applicant.hasDebt" label="Heeft u schulden?" inset></v-switch>

                <template v-if="applicant.hasDebt">
                    <v-file-input-dropzone
                        v-model="applicant.debtOverviews"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg overzicht (word document) van schulden toe, sleep bestand hierheen."
                        style="height: 200px"
                        @file-added="debtOverviewAdded"
                        @file-removed="debtOverviewRemoved"
                        :error="hasErrors('debtOverviews')" :error-messages="handleErrors('debtOverviews')"
                    ></v-file-input-dropzone>

                    <v-switch
                        class="pl-4"
                        v-model="applicant.hasDebtSettlement"
                        label="Schuldregeling of WSNP"
                        inset
                    ></v-switch>
                </template>

                <h3>Spaargeld</h3>
                <v-switch class="pl-4" v-model="applicant.hasSavings" label="Heeft u spaargeld?" inset></v-switch>

                <template v-if="applicant.hasSavings">
                    <v-float-field :error="hasErrors('savingsAmount')" :error-messages="handleErrors('savingsAmount')" v-model="applicant.savingsAmount" prefix="€" label="Hoeveel?"></v-float-field>

                    <v-textarea :error="hasErrors('savingsReason')" :error-messages="handleErrors('savingsReason')" v-model="applicant.savingsReason" label="Waar spaart u voor?"></v-textarea>

                    <v-file-input-dropzone
                        v-model="applicant.savingsStatements"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg uw bankafschriften van uw spaarrekening van de afgelopen 2 maanden toe."
                        class="my-4"
                        style="height: 200px"
                        @file-added="savingsStatementAdded"
                        @file-removed="savingsStatementRemoved"
                        :error="hasErrors('savingsStatements')" :error-messages="handleErrors('savingsStatements')"
                    ></v-file-input-dropzone>
                </template>

                <h3>Bankafschriften betaalrekening (van laatste 2 maanden)</h3>

                <v-file-input-dropzone
                    v-model="applicant.bankStatements"
                    tooltip="Klik hier of sleep bestanden naar dit vlak"
                    label="Voeg uw bankafschriften van de afgelopen 2 maanden toe."
                    class="my-4"
                    style="height: 200px"
                    @file-added="bankStatementAdded"
                    @file-removed="bankStatementRemoved"
                    :error="hasErrors('bankStatements')" :error-messages="handleErrors('bankStatements')"
                ></v-file-input-dropzone>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Volgende</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';
import VFileInputDropzone from '@/components/VFileInputDropzone';
import VFloatField from '@/components/VFloatField';
import BackendService from '../services/BackendService';
import Attachment from '../types/Attachment';

export default {
    name: 'step4-capital',
    components: {
        ApplicationStepper,
        VErrorMessages,
        VFileInputDropzone,
        VFloatField,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            hasDebt: null,
            debtOverviews: [],
            hasDebtSettlement: null,
            hasSavings: null,
            savingsAmount: null,
            savingsReason: null,
            savingsStatements: [],
            bankStatements: [],
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step4' }),
    },
    created: function() {
        const that = this;

        this.step4Load().then(function() {
            that.applicant.hasDebt = that.vuex.applicant.hasDebt;
            that.applicant.debtOverviews = that.vuex.applicant.debtOverviews;
            that.applicant.hasDebtSettlement = that.vuex.applicant.hasDebtSettlement;
            that.applicant.hasSavings = that.vuex.applicant.hasSavings;
            that.applicant.savingsAmount = that.vuex.applicant.savingsAmount;
            that.applicant.savingsReason = that.vuex.applicant.savingsReason;
            that.applicant.savingsStatements = that.vuex.applicant.savingsStatements;
            that.applicant.bankStatements = that.vuex.applicant.bankStatements;

            that.loaded = true;
        });
    },

    methods: {
        ...mapActions(['step4Load', 'step4Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        attachmentAdded(collection, type, file, errorKey) {
            let dis = this;
            const attachment = new Attachment();
            attachment.filename = file.name;
            attachment.isComplete = false;
            attachment.percentCompleted = 0;

            collection.push(attachment);

            BackendService.applicantAttachmentAdd(type, file, function (progressEvent) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                attachment.percentCompleted = percentCompleted;
            }).then(function (response) {
                attachment.id = response.data.data.id;
                if (errorKey !== undefined) {
                    dis.$delete(dis.errorDetails, errorKey)
                }
            }).catch(function (error) {
                collection.splice(collection.indexOf(attachment), 1);
                if (errorKey !== undefined) {
                    dis.errorDetails[errorKey] = {"fileupload": "Uploaden mislukt, mogelijk is het bestand te groot!"};
                }
            });
        },
        attachmentRemoved(collection, attachment) {
            attachment.isInProgress = true;
            BackendService.attachmentRemove(attachment.id)
                .then(function() {
                    // reactively remove file from collection
                    collection.splice(collection.indexOf(attachment), 1);
                })
                .finally(function() {
                    attachment.isInProgress = false;
                });
        },
        debtOverviewAdded(file) {
            return this.attachmentAdded(this.applicant.debtOverviews, Attachment.prototype.TYPE_DEBT_OVERVIEW, file, "debtOverviews");
        },
        debtOverviewRemoved(attachment) {
            return this.attachmentRemoved(this.applicant.debtOverviews, attachment);
        },
        savingsStatementAdded(file) {
            return this.attachmentAdded(
                this.applicant.savingsStatements,
                Attachment.prototype.TYPE_SAVINGS_STATEMENT,
                file,
                "savingsStatements"
            );
        },
        savingsStatementRemoved(attachment) {
            return this.attachmentRemoved(this.applicant.savingsStatements, attachment);
        },
        bankStatementAdded(file) {
            return this.attachmentAdded(this.applicant.bankStatements, Attachment.prototype.TYPE_BANK_STATEMENT, file, 'bankStatements');
        },
        bankStatementRemoved(attachment) {
            return this.attachmentRemoved(this.applicant.bankStatements, attachment);
        },
        getPayload: function() {
            return {
                applicant: {
                    hasDebt: this.applicant.hasDebt === true,
                    hasDebtSettlement: this.applicant.hasDebtSettlement === true,
                    hasSavings: this.applicant.hasSavings === true,
                    savingsAmount: this.applicant.savingsAmount,
                    savingsReason: this.applicant.savingsReason,
                },
            };
        },
        back: function() {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step4Submit(this.getPayload()).finally(function() {
                that.$router.push({ name: 'step3_household' });
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step4Submit(this.getPayload())
                .then(function() {
                    that.$router.push({ name: 'step5_car' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
